import "core-js/modules/es6.regexp.replace";

/**
 * Utility module for number related helper functions.
 *
 */
import numeral from 'numeral'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import isNaN from 'lodash/isNaN';
/**
 * Constrains the number between the min and max values.
 *
 * @param {number} num The number to be constrained to.
 * @param {number} min The minimum limit
 * @param {number} max The maximum limit.
 *
 * @returns {number}
 */

export function constrain(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
export function formatCurrency(input, includeCents) {
  var formatted = input;
  var formatString = '$0,0';

  if (includeCents) {
    formatString += '.00';
  }

  if (isNaN(formatted)) {
    formatted = 0;
  }

  return numeral(formatted).format(formatString);
}
export function formatPercent(input, formatterStr) {
  var formatted = input;

  if (isNaN(formatted)) {
    formatted = 0;
  }

  return numeral(formatted).format(formatterStr || '0.0[00]%');
}
export function value(formattedInput) {
  return numeral(formattedInput).value();
}
export function formatPhoneNumber(phone) {
  if (typeof phone !== 'string') {
    return '';
  }

  var newPhone = phone.replace(/[^\d]/g, '');

  switch (newPhone.length) {
    case 10:
      // 1231231234 -> (123) 123-1234
      newPhone = newPhone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      break;

    case 11:
      // +18001231234 -> (800) 123-1234
      newPhone = newPhone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4');
      break;

    default: // return phone number as is

  }

  return newPhone;
}
export default {
  constrain: constrain,
  formatCurrency: formatCurrency,
  formatPercent: formatPercent,
  value: value,
  formatPhoneNumber: formatPhoneNumber
};